import * as d3 from 'd3-selection'
import * as util from 'infographic-util'

/*
 * This draws a linear gradient from top to bottom. It's used by the inner
 * arc of the cycle
 */
const innerOverlay = selection => {
  selection.each(function (d) {
    // Add the linear gradient used by the inner ring overlay
    // This is always needed and doesn't change based on data
    let enter = d3.select(this)
                  .selectAll('linearGradient.cycle-inner-overlay-gradient')
                  .data([d])
                  .enter()
                  .append('linearGradient')
                    .attr('class', 'cycle-inner-overlay-gradient')
                    .attr('id', 'cycle-inner-overlay-gradient')
                    .attr('x1', 0) // top to bottom gradient
                    .attr('x2', 0)
                    .attr('y1', 0)
                    .attr('y2', 1)

    enter.append('stop').attr('offset', '0')
    enter.append('stop').attr('offset', '1')
  })
}

/*
 * This draws two radial gradients used to decorate the outer ring of the
 * cycle arcs
 */
const outerRing = selection => {
  selection.each(function (d) {
    let data = [{
        id: 'cycle-outer-ring-upper',
        cy: '0%',
        r: '90%',
        fy: '0%',
        stops: ['50%', '100%']
      }, {
        id: 'cycle-outer-ring-lower',
        cy: '100%',
        r: '90%',
        fy: '70%',
        stops: ['50%', '100%']
    }]

    // Add the radial gradients used by the outer ring overlay
    let enter = d3.select(this)
                    .selectAll('radialGradient.cycle-outer-ring')
                    .data(data)
                    .enter()
                    .append('radialGradient')
                      .attr('id', d => d.id)
                      .attr('class', d => `cycle-outer-ring ${d.id}`) // for css
                      .attr('cy', d => d.cy)
                      .attr('fy', d => d.fy)
                      .attr('r', d => d.r)

    enter.append('stop').attr('offset', d => d.stops[0])
    enter.append('stop').attr('offset', d => d.stops[1])
  })
}

const filter = selection => {
  selection.each(function (d) {
    let enter = d3.select(this)
                  .selectAll('g.cycle-filters')
                  .data([d])
                  .enter()
                  .append('g')
                    .attr('class', 'cycle-filters')

    // Outer ring upper filter
    enter.append('filter')
         .attr('id', 'cycle-outer-ring-upper-filter')
         .html(`
            <feOffset dx="0" dy="4"></feOffset>
            <feGaussianBlur result="offset-blur" stdDeviation="2"></feGaussianBlur>
            <feComposite operator="out" in="SourceAlpha" in2="offset-blur" result="inverse"></feComposite>
            <feFlood result="color" flood-color="white"></feFlood>
            <feComposite operator="in" in="color" in2="inverse"></feComposite>`)

    // Outer ring lower filter
    enter.append('filter')
         .attr('id', 'cycle-outer-ring-lower-filter')
         .html(`
            <feOffset dx="0" dy="-4"></feOffset>
            <feGaussianBlur result="offset-blur" stdDeviation="2"></feGaussianBlur>
            <feComposite operator="out" in="SourceAlpha" in2="offset-blur" result="inverse"></feComposite>
            <feFlood result="color" flood-color="black"></feFlood>
            <feComposite operator="in" in="color" in2="inverse"></feComposite>`)
  })
}

export default (selection, colors, transition) => {
  selection.each(function (d) {
    d3.select(this)
      .call(util.coloredGradients, 'cycle', colors, [0, .33, .66, 1], transition)
      .call(innerOverlay)
      .call(outerRing)
      .call(filter)
  })
}
